/**
 * Copyright Highway9 Networks Inc.
 */
import { Route, RouteProps } from "react-router-dom";
import { useAppAbility } from "~/rbac";
import type { AppAction, AppSubject } from "~/types/rbac";

type PermissionRouteProps = RouteProps & {
  /** One or more RBAC subjects — all must pass the action check for the route to render. */
  subject: AppSubject | AppSubject[];
  /** RBAC action to check. Defaults to 'VIEW'. */
  action?: AppAction;
  /** Additional boolean gate ANDed with the permission check (e.g. feature flags). Defaults to true. */
  condition?: boolean;
  /** When true, renders the route unconditionally — bypasses the permission check entirely (e.g. operator role fallback). */
  fallback?: boolean;
};

const PermissionRoute = ({ subject, action = "VIEW", condition = true, fallback = false, ...routeProps }: PermissionRouteProps) => {
  const ability = useAppAbility();
  const subjects = Array.isArray(subject) ? subject : [subject];
  const permitted = subjects.every((s) => ability.can(action, s));
  if (!fallback && (!condition || !permitted)) return null;
  return <Route {...routeProps} />;
};

export default PermissionRoute;
